// extracted by mini-css-extract-plugin
module.exports = {"facetDescriptionButton":"FacetDescriptionButton_facetDescriptionButton__B16zg"};